// extracted by mini-css-extract-plugin
export default {"icon":"DatePicker_icon__zx0hl","reactDatePickerWrapper":"DatePicker_reactDatePickerWrapper__MoiCX","reactDatePickerPopper":"DatePicker_reactDatePickerPopper__VBLMD"};